const getApartment = (state) => {
	return state.apartment;
};

export default {
	getApartment
};
